import { lazy } from 'react';
var DOC_PAGE = ['01', '02', '03', '04', '05', '06', '07'];
var ORD_ROUTES = DOC_PAGE.map(function (obj) { return ({
    path: "/ORD00/ORD000" + obj,
    component: lazy(function () { return import("view/Project/ORD/ORD000" + obj); }),
}); });
export default ORD_ROUTES;
